import Float from "./Float"
import Detalle from "./Detalle"
import DetalleVenta from "./DetalleVenta"
import Cliente from "./Cliente"
export default {
    Float,
    Detalle,
    DetalleVenta,
    Cliente
}